export const radialConstructor = (color0: string, color2: string, operation = '94.85% 100% at 1.84% 0%'): string => (
  `radial-gradient(${operation}, ${color0} 0%, ${color2} 100%)`
)
